module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "content-title",
    attrs: {
      "id": "calibre_toc_1"
    }
  }, [_vm._v("Navigating College With the 7 Habits")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A Digital Book to Help You Succeed In School and in Life")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Sean Covey")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_c('img', {
    staticClass: "_idgenobjectattribute",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/MangobzLogo.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal2",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mango Publishing"), _c('br', {
    staticClass: "calibre1"
  })]), _c('span', {
    staticClass: "charoverride1"
  }, [_vm._v("Coral Gables")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73daf7e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ebook_split_000.vue
// module id = 57
// module chunks = 0